import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { H2 } from 'foundations-components/transitional/components/H2';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import useContentCrmObject from '../hooks/useContentCrmObject';
import { useSelector } from 'react-redux';
import { getUnifiedPublishType } from '../../../redux/selectors/publishSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * This modal is configured to be only used by ContentTypes on CMP platform
 */
const PublishConfirmModal = ({
  publishButtonTextKey,
  confirmPublishActionProps: {
    publishConfirmModalBodyContent,
    publishConfirmDisabled,
    publishConfirmDisabledTooltip
  },
  publish,
  closeModal
}) => {
  const {
    contentCrmObjectPublishType
  } = useContentCrmObject();
  const unifiedPublishType = useSelector(getUnifiedPublishType);
  return /*#__PURE__*/_jsxs(Modal, {
    width: 550,
    "data-selenium": "confirm-modal",
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: closeModal
      }), /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `publishConfirmModal.header.${contentCrmObjectPublishType || unifiedPublishType}`
        })
      })]
    }), /*#__PURE__*/_jsx(DialogBody, {
      children: publishConfirmModalBodyContent
    }), /*#__PURE__*/_jsx(DialogFooter, {
      children: /*#__PURE__*/_jsxs(TFlex, {
        children: [/*#__PURE__*/_jsx(Tooltip, {
          disabled: !publishConfirmDisabled,
          title: publishConfirmDisabledTooltip,
          children: /*#__PURE__*/_jsx(Button, {
            "data-test-id": "publish-confirm-button",
            "data-onboarding": "publish-confirm-button",
            use: "primary",
            disabled: publishConfirmDisabled,
            onClick: () => {
              publish(contentCrmObjectPublishType || unifiedPublishType);
              closeModal();
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: publishButtonTextKey
            })
          })
        }), /*#__PURE__*/_jsx(Button, {
          "data-test-id": "publish-confirm-secondary-button",
          use: "secondary",
          onClick: closeModal,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "publishConfirmModal.footer.cancel"
          })
        })]
      })
    })]
  });
};
export default PublishConfirmModal;